export var BusinessRelationType = /*#__PURE__*/ function(BusinessRelationType) {
    BusinessRelationType["Native"] = "native";
    BusinessRelationType["NoRelation"] = "noRelation";
    return BusinessRelationType;
}({});
